import { render, staticRenderFns } from "./plmCostRollup.vue?vue&type=template&id=35b142f2&scoped=true"
import script from "./plmCostRollup.vue?vue&type=script&lang=js"
export * from "./plmCostRollup.vue?vue&type=script&lang=js"
import style0 from "./plmCostRollup.vue?vue&type=style&index=0&id=35b142f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b142f2",
  null
  
)

export default component.exports